angular
    .module('garanteasyApp')
    .component('listItemProduct', {
        templateUrl: 'app/components/list-item/product/product.component.html',
        controller: ListItemProductComponentController,
        controllerAs: 'vm',
        bindings: {
            product: '<'
        }
    });

ListItemProductComponentController.$inject = ['DataUtils'];

function ListItemProductComponentController(DataUtils) {
    var vm = this;
    vm.abbreviate = DataUtils.abbreviate;
}
